import {
  Node,
  Cluster,
  WorkloadMigrationStatusMigrationStatusEnum,
} from '@cast/types';

import { BIN_PACKING_READY_QUERY_PARAM } from '../_constants/query-params';
import { NODE_WORKLOADS_TABLE_URL_KEY } from '../_constants/table-url-keys';
import { NodeDetailsTab } from '../types';

import { makeSearchQuery } from '@cast/shared-search-ui';

type NodesLinkArgs = {
  clusterId: string;
};

export const makeNodesLink = ({ clusterId }: NodesLinkArgs): string => {
  const link = `/external-clusters/${clusterId}/nodes`;
  return link;
};

type NodeDetailsFilters = {
  [BIN_PACKING_READY_QUERY_PARAM]?: `${WorkloadMigrationStatusMigrationStatusEnum}`;
};

type NodeDetailsLinkArgs = {
  clusterId: Cluster['id'];
  nodeId: Node['id'];
  tab?: `${NodeDetailsTab}`;
  filters?: NodeDetailsFilters;
};

export const makeNodeDetailsLink = ({
  clusterId,
  nodeId,
  tab = 'overview',
  filters,
}: NodeDetailsLinkArgs): string => {
  const link = `/external-clusters/${clusterId}/nodes/${nodeId}/${tab}`;

  const values = Object.entries(filters || {}).reduce<Record<string, string>>(
    (acc, [key, value]) => {
      acc[key] = value;
      return acc;
    },
    {}
  );

  return `${link}?${makeSearchQuery({
    id: NODE_WORKLOADS_TABLE_URL_KEY,
    values,
  })}`;
};
